import { useContext } from 'react';

import * as glob from '../Misc/Globals.js';
import {parseBuildQuery} from '../Misc/BuildImportExport.js'
import {ComparerStateContext, ComparerStateDispatchContext} from 
	'../Contexts/ComparerStateContext.jsx'

import ACAssembly from './ACAssembly.jsx'
import ACStats from './ACStats.jsx'
import InfoBox from './InfoBox.jsx'

const buildLoaderTooltip = 'Insert a build link generated by the CREATE BUILD LINK button ' +
	'in the build section.';

const ComparerColumnHeader = ({pos, inputHandler, showStats}) => {
	const state = useContext(ComparerStateContext);
	const stateDispatch = useContext(ComparerStateDispatchContext);
	const inputFieldString = state.inputFieldStrings[pos];

	const setInputFieldString = event => stateDispatch(
		{target: 'inputFieldStrings', pos: pos, value: event.target.value}
	);
	const toggleShowStats = () => stateDispatch({target: 'showStats', pos: pos});

	return(
		<div style={{...glob.dottedBackgroundStyle(), padding: '10px 0px', 
			marginBottom: '10px'}}>
		<div style={{display: 'flex', justifyContent: 'center', alignItems: 'center',
			gap: '5px', padding: '0px 0px 10px 0px'}}>
			<div style={{width: '16px'}}>
				<InfoBox name={'build-loader-infobox'} tooltip={buildLoaderTooltip}
					place='bottom-start'/>
			</div>
			<div style={{width: 'auto'}}>BUILD LINK:</div>
			<form onSubmit={inputHandler}>
				<input
					className='link-tooltip-anchor'
					style={{width: '150px', height: '30px', 
						backgroundColor: glob.paletteColor(3)}}
					value={inputFieldString}
					onChange={setInputFieldString}
				/>
			<input type="submit" value="LOAD" style={{marginLeft: '10px', padding: '3px 10px'}}/>
			</form>		
		</div>
		<button 
			style={{display: 'block', margin: 'auto', width: '200px'}}
			onClick={toggleShowStats}
		>
			{showStats ? 'SHOW ASSEMBLY' : 'SHOW SPECS'}
		</button>
		</div>
	)
}

const ComparerColumnFooter = ({pos, disabled}) => {
	const state = useContext(ComparerStateContext);
	const stateDispatch = useContext(ComparerStateDispatchContext);

	const checked = state.checked[pos];
	const toggleCompareSwitch = () => stateDispatch({target: 'checked', pos: pos})
	return(
		<div style={{display: 'flex', justifyContent:'center', gap: '20px', 
			alignItems: 'center', backgroundColor: glob.paletteColor(3), padding: '10px 0px'}}>
			COMPARE
			<input
				type='checkbox'
				style={{transform: 'scale(1.25)'}}
				disabled={disabled}
				checked={checked}
				onChange={toggleCompareSwitch}
			/>
		</div>
	)
}

const ComparerColumn = ({pos, inputHandler, comparedParts}) => {

	const state = useContext(ComparerStateContext);

	const build = state.builds[pos];
	const showStats = state.showStats[pos];

	// compared parts === undefined -> no pair of builds are compared
	// compared parts === null -> a pair of builds is compared but this is not in the pair
	// compared parts === obj -> a pair of builds is compared and this is in the pair

	return(
		<div style={{width: '24%', filter: comparedParts === null ? 'brightness(0.5)' : 'none'}}>
			<ComparerColumnHeader
				pos={pos}
				inputHandler={inputHandler}
				showStats={showStats}
			/>
			<div style={{height: '655px', marginBottom: '5px'}}>
				{
					showStats ? 
					<ACStats 
						acParts={build}
						comparedParts={comparedParts === undefined ? null : comparedParts}
						buildCompareMode={true}
					/> :
					<ACAssembly parts={build} previewSetter={null} />
				}
			</div>
			<ComparerColumnFooter pos={pos} disabled={comparedParts === null}/>
		</div>
	)
}

const CompareBuildsComponent = () => {
	const state = useContext(ComparerStateContext);
	const stateDispatch = useContext(ComparerStateDispatchContext);

	const posInputHandler = (event, pos) => {
		event.preventDefault();
		let query;
		try {
			const url = new URL(event.currentTarget[0].value);
			const params = new URLSearchParams(url.search);
			query = params.get('build')
		} catch {
			query = ''
		}
		const build = parseBuildQuery(query);
		stateDispatch({target: 'builds', pos: pos, value: build})
	}

	// Detect if two comparison checkbox are ticked and set the compared builds
	// accordingly
	let comparedBuildsPos = [];
	state.checked.map((b, pos) => {
		if(b) comparedBuildsPos.push(pos);
		return null;
	});
	let comparedBuilds;
	if(comparedBuildsPos.length === 2) {
		comparedBuilds = new Array(state.builds.length).fill(null);
		comparedBuilds[comparedBuildsPos[0]] = state.builds[comparedBuildsPos[1]];
		comparedBuilds[comparedBuildsPos[1]] = state.builds[comparedBuildsPos[0]];
	} else {
		comparedBuilds = new Array(state.builds.length).fill(undefined);
	}

	const range = [...Array(state.builds.length).keys()];

	return (
		<div style={{display: 'flex', justifyContent: 'space-around', marginTop: '25px'}}>
		{
			range.map(
				(pos) => {
					return(
						<ComparerColumn
							pos={pos}
							inputHandler={(ev) => posInputHandler(ev, pos)}
							comparedParts={comparedBuilds[pos]}
							key={pos}
						/>
					)
				}
			)
		}
		</div>
	)
}

export default CompareBuildsComponent;